/**
 * Handles the product slider functionality for the Ombraz V2 Collection PDP
 */
function v2CollectionPdpSlider() {
  // Select all necessary elements within the card
  const cards = Array.from(
    document.querySelectorAll(".ombraz-product-v2__card")
  );

  if (!cards.length) return;

  cards.forEach((card) => {
    const featuredImageElement = card.querySelector("[data-feaure-image]");
    const sideShieldToggle = card.querySelector("label input[type=checkbox]");
    const productImageUrl = card.querySelector(
      ".ombraz-product-v2__card-feature-image-link"
    );
    const productReviewUrl = card.querySelector(".klaviyo-star-rating-wrapper");
    const productCardUrl = card.querySelector(".ombraz-product-v2__card-url");
    const productVariantTitle = card.querySelector(
      ".ombraz-product-v2__card-variant-title > p"
    );
    const productPrice = card.querySelector(".ombraz-product-v2__price > p");
    const sizeButtons = {
      regular: card.querySelector("label[for^=regular] input[type=radio]"),
      narrow: card.querySelector("label[for^=narrow] input[type=radio]"),
      xl: card.querySelector("label[for^=xl] input[type=radio]"),
    };
    const slides = Array.from(
      card.querySelectorAll(".ombraz-product-v2-slide")
    );
    const quickAddButton = card
      .closest(".ombraz-product-v2__grid-item")
      .querySelector(".ombraz-product-v2__add-to-cart button");

    if (!featuredImageElement || !slides.length) return;

    // Initialize variables
    let activeSlide = slides[0];
    let isSideShieldAdded = false;
    let currentSize = "regular"; // Default size
    let alertShownForCurrentSlide = false;

    /**
     * Preloads an image to improve performance
     * @param {string} url - The URL of the image to preload
     */
    function preloadImage(url) {
      const img = new Image();
      img.src = url;
    }

    /**
     * Updates the product information based on the selected slide and size
     * @param {HTMLElement} slide - The selected slide element
     * @param {string} size - The selected size (default: currentSize)
     */
    function updateProductInfo(slide, size = currentSize) {
      const slideProductId =
        slide.getAttribute(`data-${size}-id`) ||
        slide.getAttribute("data-slide-product-id");
      const baseProductUrl = slide
        .getAttribute("data-product-url")
        .split("?")[0];
      const slideProductTitle = slide.getAttribute("data-product-title");
      const slideProductPrice = parseInt(
        slide.getAttribute(`data-${size}-price`) ||
          slide.getAttribute("data-product-price")
      );

      const compareAtPrice = card.querySelector("[data-base-compare-price]");
      const sideShieldPrice =
        parseInt(slide.getAttribute("data-sideshield-price")) || 65;

      // Store original prices if not already stored
      if (!card.dataset.originalPrice) {
        card.dataset.originalPrice = slideProductPrice;
      }
      if (compareAtPrice && !card.dataset.originalComparePrice) {
        card.dataset.originalComparePrice = parseInt(
          compareAtPrice.textContent.replace(/[^0-9]/g, "")
        );
      }

      // Calculate prices
      let currentPrice = parseInt(card.dataset.originalPrice);
      let currentComparePrice = compareAtPrice
        ? parseInt(card.dataset.originalComparePrice)
        : 0;

      if (isSideShieldAdded) {
        currentPrice += sideShieldPrice;
        if (compareAtPrice) {
          currentComparePrice += sideShieldPrice;
        }
      }

      // Update prices
      if (productPrice) {
        productPrice.textContent = `$${currentPrice}`;
      }

      if (compareAtPrice) {
        compareAtPrice.textContent = `$${currentComparePrice}`;
      }

      let updatedProductUrl = `${baseProductUrl}?variant=${slideProductId}`;

      // Add side shield query param if side shield is added
      if (isSideShieldAdded) {
        updatedProductUrl += "&addons=sideshields";
      }

      card.setAttribute("data-default-product-id", slideProductId);
      if (productCardUrl) productCardUrl.href = updatedProductUrl;
      if (productImageUrl) productImageUrl.href = updatedProductUrl;
      if (productReviewUrl)
        productReviewUrl.href = `${updatedProductUrl}#pdp-review-section`;

      if (productVariantTitle) {
        const slideCustomTitle = slide.getAttribute("data-custom-title");
        let getFirstWord = slideCustomTitle.split(" ")[0];

        // If the getFirstWord contains "matte" then add suffix "Brown" to the title
        if (getFirstWord === "Matte" || getFirstWord === "matte") {
          getFirstWord = "Matte Brown";
        }

        productVariantTitle.textContent = `${getFirstWord}, ${slideProductTitle}`;
      }

      updateFeaturedImage(slide);

      // Check availability of the selected frame size
      const isAvailable =
        slide.getAttribute(`data-is-${size}-available`) === "true";

      // Update quickAddButton if it exists
      if (quickAddButton) {
        quickAddButton.setAttribute("data-product-id", slideProductId);
        // Only set side shield ID if side shield is available
        if (card.hasAttribute("data-sideshield-id")) {
          quickAddButton.setAttribute(
            "data-side-shield-id",
            card.getAttribute("data-sideshield-id")
          );
        }

        // Update button text and disabled state based on availability
        if (isAvailable) {
          quickAddButton.textContent = "Quick Add";
          quickAddButton.disabled = false;
          quickAddButton.style.cursor = "pointer";
          quickAddButton.style.opacity = 1;
        } else {
          quickAddButton.textContent = "Out of Stock";
          quickAddButton.disabled = true;
          quickAddButton.style.cursor = "not-allowed";
          quickAddButton.style.opacity = 0.5;
        }
      }
    }

    /**
     * Updates the featured image based on the selected slide and side shield status
     * @param {HTMLElement} slide - The selected slide element
     */
    function updateFeaturedImage(slide) {
      const currentSlideImageSrc =
        slide.querySelector("[data-thumb-image]")?.src;
      const sideShieldImageSrc = slide.getAttribute("data-side-shield-image");

      // Preload the images
      preloadImage(currentSlideImageSrc);
      if (sideShieldImageSrc) {
        preloadImage(sideShieldImageSrc);
      }

      if (isSideShieldAdded && sideShieldImageSrc) {
        // Use requestAnimationFrame for smoother transition
        requestAnimationFrame(() => {
          featuredImageElement.src = sideShieldImageSrc;
        });
      } else {
        requestAnimationFrame(() => {
          featuredImageElement.src = currentSlideImageSrc;
        });
      }
    }

    // Add event listeners to slides
    slides.forEach((slide) => {
      slide.addEventListener("click", (event) => {
        event.stopPropagation();
        slides.forEach((s) => s.classList.remove("is-active"));
        slide.classList.add("is-active");
        activeSlide = slide;
        alertShownForCurrentSlide = false; // Reset the alert flag
        updateProductInfo(slide, currentSize);

        // Check availability of the selected frame size
        const isAvailable =
          slide.getAttribute(`data-is-${currentSize}-available`) === "true";

        // Update quickAddButton if it exists
        if (quickAddButton) {
          if (isAvailable) {
            quickAddButton.textContent = "Quick Add";
            quickAddButton.disabled = false;
            quickAddButton.style.cursor = "pointer";
            quickAddButton.style.opacity = 1;
          } else {
            quickAddButton.textContent = "Out of Stock";
            quickAddButton.disabled = true;
            quickAddButton.style.cursor = "not-allowed";
            quickAddButton.style.opacity = 0.5;
          }
        }
      });

      // Handle side shield toggle
      if (sideShieldToggle) {
        sideShieldToggle.addEventListener("change", (event) => {
          isSideShieldAdded = event.target.checked;
          const sideShieldImageSrc = activeSlide.getAttribute(
            "data-side-shield-image"
          );

          if (
            isSideShieldAdded &&
            !sideShieldImageSrc &&
            !alertShownForCurrentSlide
          ) {
            injectCustomMessage(
              "Unfortunately, the image of the side shield is currently unavailable.",
              card.querySelector(".ombraz-product-v2__price"),
              true
            );
            alertShownForCurrentSlide = true;
          } else if (!isSideShieldAdded) {
            injectCustomMessage(
              "",
              card.querySelector(".ombraz-product-v2__price"),
              false
            );
            alertShownForCurrentSlide = false;
          }

          if (isSideShieldAdded) {
            updateProductInfo(activeSlide);
          } else {
            updateProductInfo(activeSlide);
          }

          updateFeaturedImage(activeSlide);
        });
      }

      /**
       * Updates the product information when a new size is selected
       * @param {string} size - The selected size
       */
      function updateSizeSelection(size) {
        currentSize = size;
        updateProductInfo(activeSlide, size);

        // Check availability of the selected frame size
        const isAvailable =
          activeSlide.getAttribute(`data-is-${size}-available`) === "true";

        // Update quickAddButton if it exists
        if (quickAddButton) {
          if (isAvailable) {
            quickAddButton.textContent = "Quick Add";
            quickAddButton.disabled = false;
            quickAddButton.style.cursor = "pointer";
            quickAddButton.style.opacity = 1;
          } else {
            quickAddButton.textContent = "Out of Stock";
            quickAddButton.disabled = true;
            quickAddButton.style.cursor = "not-allowed";
            quickAddButton.style.opacity = 0.5;
          }
        }
      }

      // Add event listeners to frame size buttons
      Object.entries(sizeButtons).forEach(([size, button]) => {
        if (button) {
          button.addEventListener("change", () => updateSizeSelection(size));
        }
      });
    });

    // Handle quick add button click
    if (quickAddButton) {
      quickAddButton.addEventListener("click", () => {
        const productId = quickAddButton.getAttribute("data-product-id");
        const sideShieldId = quickAddButton.hasAttribute("data-side-shield-id")
          ? quickAddButton.getAttribute("data-side-shield-id")
          : null;
        const items = [
          {
            id: parseInt(productId),
            quantity: 1,
          },
        ];

        if (isSideShieldAdded && sideShieldId) {
          items.push({
            id: parseInt(sideShieldId),
            quantity: 1,
          });
        }

        addToCart(items, quickAddButton);
      });
    }

    // Initialize product info with the first slide
    updateProductInfo(activeSlide);
  });
}

/**
 * Handles simple product cards that don't require the full slider functionality
 */
function handleSimpleProductCards() {
  const simpleCards = Array.from(
    document.querySelectorAll(".ombraz-product-v2__card")
  );

  if (!simpleCards.length) return;

  simpleCards.forEach((card) => {
    const quickAddButton = card.querySelector(
      ".ombraz-product-v2__add-to-cart button"
    );

    if (!quickAddButton) return;

    const productId = card.getAttribute("data-product-id");

    quickAddButton.addEventListener("click", () => {
      const items = [
        {
          id: parseInt(productId),
          quantity: 1,
        },
      ];

      addToCart(items, quickAddButton);
    });
  });
}

/**
 * Injects or removes a custom message near the target element
 * @param {string} message - The message to inject
 * @param {HTMLElement} targetElement - The element to inject the message near
 * @param {boolean} shouldInject - Whether to inject or remove the message
 */
function injectCustomMessage(message, targetElement, shouldInject) {
  const existingMessage = targetElement.parentNode.querySelector(
    ".custom-alert-message"
  );

  if (shouldInject) {
    // If the message does not exist, create and inject it
    if (!existingMessage) {
      const newDiv = document.createElement("div");
      newDiv.className = "custom-alert-message";
      newDiv.textContent = message;

      // Insert the new div before the target element
      if (targetElement) {
        targetElement.parentNode.insertBefore(newDiv, targetElement);
      }
    }
  } else {
    // Remove the existing message if checkbox is unchecked
    if (existingMessage) {
      existingMessage.remove();
    }
  }
}

/**
 * Capitalizes the first letter of a string
 * @param {string} str - The string to capitalize
 * @returns {string} The capitalized string
 */
function toCapitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Adds items to the cart and updates the UI accordingly
 * @param {Array} items - An array of items to add to the cart
 * @param {HTMLElement} quickAddButton - The quick add button element
 */
function addToCart(items, quickAddButton) {
  if (quickAddButton) {
    quickAddButton.textContent = "Adding cart...";
    quickAddButton.disabled = true;
    quickAddButton.style.cursor = "not-allowed";
    quickAddButton.style.opacity = 0.5;
  }

  const formData = {
    items: items,
  };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((_data) => {
      setTimeout(() => {
        if (quickAddButton) {
          quickAddButton.textContent = "Cart added";
          quickAddButton.disabled = false;
          quickAddButton.style.cursor = "pointer";
          quickAddButton.style.opacity = 1;

          setTimeout(() => {
            if (quickAddButton) {
              quickAddButton.textContent = "Quick Add";
            }
          }, 2000);
          SLIDECART_UPDATE();
          SLIDECART_OPEN();
        }
      }, 1000);
    })
    .catch((_error) => {
      if (quickAddButton) {
        quickAddButton.textContent = "Adding cart...";
        quickAddButton.disabled = false;
        quickAddButton.style.cursor = "pointer";
        quickAddButton.style.opacity = 1;

        setTimeout(() => {
          if (quickAddButton) {
            quickAddButton.textContent = "Quick Add";
          }
        }, 3000);
      }
    });
}

// Initialize the functionality when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  v2CollectionPdpSlider();
  handleSimpleProductCards();
});
